.mentions-input-textarea::-webkit-scrollbar {
  width: 8px;
}

.mentions-input-textarea::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 8px;
}

.mentions-input-textarea::-webkit-scrollbar-thumb {
  background-color: #F47A20;
  border-radius: 8px;
  border: 2px solid #ffffff;
}

.mentions-input-textarea::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}

.mentions-input-textarea {
  scrollbar-width: thin;
  scrollbar-color: #F47A20 #ffffff;
}
